import { BulletList as Base } from "@corca/tiptap";

import { LineWrapperView } from "./utils/LineWrapperView";

export const BulletList = Base.extend({
  addNodeView() {
    return (props) => {
      return new LineWrapperView(props, {
        renderNodeAsChildIn: ["blockquote", "callout", "tableCell", "tableHeader"],
      });
    };
  },
});
